import React from 'react';
import cx from 'classnames';

import T from 'Utilities/texts';

import imageTwoJpg from '../../../../../../client/assets_seller/about_us/dealer-image.jpg';
import imageTwoWebp from '../../../../../../client/assets_seller/about_us/dealer-image.webp';
import imageOneJpg from '../../../../../../client/assets_seller/about_us/iosApp.jpg';
import imageOneWebp from '../../../../../../client/assets_seller/about_us/iosApp.webp';

import ImgBox from './imgBox';

import styles from './Info.scss';

const Info = () => (
  <section className={styles.outer}>
    <div className={cx(styles.infoBox, styles.reverse)}>
      <div className={styles.textBox}>
        <p className="mw-i">
          {T.translate('aboutPage.info.photoApp')}
        </p>
      </div>
      <ImgBox
        imgHeight={1248}
        imgPng={imageOneJpg}
        imgWebp={imageOneWebp}
        imgWidth={2040}
        name="Motorway photos app"
      />
    </div>
    <div className={styles.infoBox}>
      <div className={styles.textBox}>
        <p className="mw-i">
          {T.translate('aboutPage.info.sellerApp')}
        </p>
      </div>
      <ImgBox
        reverse
        imgHeight={898}
        imgPng={imageTwoJpg}
        imgWebp={imageTwoWebp}
        imgWidth={1371}
        name="Motorway seller app"
      />
    </div>
  </section>
);

export default Info;
